import { Typography, Button, Input, Form, Layout, Card, Flex } from "antd";
import { Link } from "react-router-dom";
const { Title } = Typography;
const ForgotPassword = () => {
  return (
    <>
      <Layout>
        <Flex
          gap="middle"
          align="center"
          justify="center"
          vertical
          style={{ minHeight: "100vh" }}
        >
          <Card className="relative">
            <img
              width={100}
              src="LogoSquare.svg"
              alt=""
              className="mx-auto absolute top-[-120px] left-0 right-0"
            />
            <Title level={3} align={"center"}>
              Forgot Password
            </Title>
            <p className="text-gray-500">
              Enter registered email address to receive reset password link
            </p>
            <Form
              name="login"
              layout="vertical"
              style={{
                maxWidth: 400,
                minWidth: 400,
                marginTop: 24,
              }}
              initialValues={{
                remember: true,
              }}
              // onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Email Address"
                name="Email"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Email Address",
                  },
                ]}
              >
                <Input size="large" />
              </Form.Item>
              <Button
                className="w-full mt-4"
                size="large"
                type="primary"
                htmlType="submit"
              >
                Send link
              </Button>
              <div className="text-center mt-4">
                <Link to="/">
                  <Button className="underline font-medium" type="link">
                    Back to login
                  </Button>
                </Link>
              </div>
            </Form>
          </Card>
        </Flex>
      </Layout>
    </>
  );
};
export default ForgotPassword;